<script setup lang="ts">
defineProps<{
  exact?: boolean
  to: string
}>()
</script>

<template>
  <NuxtLink
    v-slot="slotProps"
    v-bind="{
      [exact ? 'exactActiveClass' : 'activeClass']:
        'bg-primary-light font-semibold text-white hover:bg-primary-light',
    }"
    :to="to"
    class="hover:bg-primary-400 inline-flex w-full items-center justify-start space-x-3 rounded-lg py-3 pl-3 pr-4 transition-colors hover:text-neutral-50"
  >
    <div class="h-6 w-6">
      <slot
        v-bind="{ isActive: slotProps?.isActive || slotProps?.isExactActive }"
        name="icon"
      />
    </div>
    <span class="truncate text-xs tracking-wide">
      <slot />
    </span>
  </NuxtLink>
</template>
